<template>
    <div class="py-12">
        <DataTable
            :title="$t('vue.users_profiles')"
            searchable
            :headers="headers"
            :items="users"
            :filters="filters"
        >
            <template #item-profile_photo_url="{ data }">
                <div class="flex justify-center">
                    <img
                        v-if="data"
                        class="h-10 w-10 rounded-full object-cover"
                        :src="data"
                        alt="User kiosk photo record"
                    />
                    <img
                        v-else
                        class="h-10 w-10 rounded-full object-cover"
                        src="https://upload.wikimedia.org/wikipedia/commons/thumb/a/ac/No_image_available.svg/600px-No_image_available.svg.png"
                        alt="User kiosk photo record stock"
                    />
                </div>
            </template>

            <template #item-custom="{ row }">
                <div class="flex w-full justify-center">
                    <AtomicButton
                        color="white"
                        size="sm"
                        @click="handleShowUser(row)"
                    >
                        <template #icon>
                            <MagnifyingGlassIcon class="h-6 w-6" />
                        </template>
                    </AtomicButton>
                </div>
            </template>
        </DataTable>
    </div>
</template>

<script lang="ts" setup>
import type IPaginationData from "@/types/Atomic/IPaginationData";
import { MagnifyingGlassIcon } from "@heroicons/vue/24/outline";
import route from "ziggy-js";
import type IUser from "@/types/Members/IUser";
import type IDataTableHeader from "@/components/Atomic/DataTable/types/IDataTableHeader";
import type { IDataTableFilter } from "@/components/Atomic/DataTable/types/IDataTableFilter";
import { router } from "@inertiajs/vue3";
import { useTranslations } from "@/composables/useTranslations";

defineProps<{
    users: IPaginationData<IUser>;
}>();

// Get access to translations
const { t } = useTranslations();

const headers: IDataTableHeader[] = [
    { text: "", id: "profile_photo_url" },
    {
        text: t("vue.id"),
        id: "id",
        sortable: true,
        sortableId: "id",
    },
    {
        text: t("vue.name"),
        id: "name",
        sortable: true,
        sortableId: "name",
    },
    {
        text: t("vue.email"),
        id: "email",
        sortable: true,
        sortableId: "email",
    },
    { text: "", id: "custom" },
];

const filters: IDataTableFilter[] = [
    {
        column: "type",
        label: t("vue.user_type"),
        values: [
            {
                label: t("vue.regular_users"),
                value: "regular",
            },
            {
                label: t("vue.admins"),
                value: "admin",
            },
        ],
    },
];

const handleShowUser = function (user: IUser) {
    router.get(
        route("kiosk.users.teams.index", {
            user: user.id,
        }),
    );
};
</script>

<style></style>
